import { render, staticRenderFns } from "./VolumeDivision.vue?vue&type=template&id=a2e4d032&scoped=true&"
import script from "./VolumeDivision.vue?vue&type=script&lang=js&"
export * from "./VolumeDivision.vue?vue&type=script&lang=js&"
import style0 from "./VolumeDivision.vue?vue&type=style&index=0&id=a2e4d032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e4d032",
  null
  
)

export default component.exports